import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

import CloudinaryImage from '../../../../cloudinary-media/image'
import {RESIZE_FULL_HERO} from '../../../../../constants'
import {getScaledSize} from '../media-height'

const Banner = ({
    desktopImage,
    mobileImage,
    imageAlt,
    variant,
    mediaSize,
    desktopMediaPosition = 'full',
    mobileMediaPosition = 'full',
    desktopHeight = '100%',
    mobileHeight = '100%',
    disableAutoCrop = false,
    eagerLoadImage = false
}) => {
    const mobileSrc = mobileImage || desktopImage

    const widthDesktop = desktopMediaPosition === 'full' ? 1920 : 960
    const heightMobile = mobileMediaPosition === 'full' ? 654 : 327
    const sizeDesktop =
        variant === 'hero'
            ? mediaSize === 'hero'
                ? {width: widthDesktop, height: 900}
                : {width: widthDesktop, height: 480}
            : {width: widthDesktop, height: 684}
    const sizeMobile = {width: 414, height: heightMobile}
    const scaledSizeDesktop = getScaledSize(sizeDesktop, desktopHeight)
    const scaledSizeMobile = getScaledSize(sizeMobile, mobileHeight)

    return (
        <>
            <Box display={{base: 'none', md: 'block'}} height="100%">
                <CloudinaryImage
                    src={desktopImage}
                    aspectRatio={
                        !disableAutoCrop
                            ? `${scaledSizeDesktop.width}:${scaledSizeDesktop.height}`
                            : undefined
                    }
                    imgSizes={{base: '100vw'}}
                    lazyload={!eagerLoadImage}
                    sizes={RESIZE_FULL_HERO}
                    alt={imageAlt}
                    styles={{
                        aspectRatio: `${scaledSizeDesktop.width} / ${scaledSizeDesktop.height}`,
                        width: '100%',
                        height: '100%',
                        objectFit: disableAutoCrop ? 'contain' : 'cover',
                        htmlWidth: scaledSizeDesktop.width,
                        htmlHeight: scaledSizeDesktop.height
                    }}
                />
            </Box>

            <Box display={{base: 'block', md: 'none'}} height="100%">
                <CloudinaryImage
                    src={mobileSrc}
                    aspectRatio={
                        !disableAutoCrop
                            ? `${scaledSizeMobile.width}:${scaledSizeMobile.height}`
                            : undefined
                    }
                    imgSizes={{base: '100vw'}}
                    lazyload={!eagerLoadImage}
                    sizes={RESIZE_FULL_HERO}
                    alt={imageAlt}
                    styles={{
                        aspectRatio: `${scaledSizeMobile.width} / ${scaledSizeMobile.height}`,
                        width: '100%',
                        height: '100%',
                        objectFit: disableAutoCrop ? 'contain' : 'cover',
                        htmlWidth: scaledSizeMobile.width,
                        htmlHeight: scaledSizeMobile.height
                    }}
                />
            </Box>
        </>
    )
}

Banner.propTypes = {
    desktopImage: PropTypes.string.isRequired,
    mobileImage: PropTypes.string,
    imageAlt: PropTypes.string,
    variant: PropTypes.string,
    mediaSize: PropTypes.string,
    desktopMediaPosition: PropTypes.string,
    mobileMediaPosition: PropTypes.string,
    desktopHeight: PropTypes.string,
    mobileHeight: PropTypes.string,
    disableAutoCrop: PropTypes.bool,
    eagerLoadImage: PropTypes.bool
}

export default Banner
